import React, { Component } from 'react'
import { connect } from 'react-redux';
import { ReactComponent as Options } from '../assets/icons/options.svg'
import { saveDrawing, enableLayering, selectedObject } from "./../actions/wizard";


export class AnnotationObj extends Component<any, any> {
  private optionsObjRef: React.RefObject<HTMLDivElement>;
  private objRef: React.RefObject<HTMLDivElement>;
  constructor(props) {
    super(props)
    this.optionsObjRef = React.createRef<HTMLDivElement>();
    this.objRef = React.createRef<HTMLDivElement>();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      showOptionsForObj: false
    }
  }

  handleClickOutside(event) {
    if (this?.optionsObjRef?.current && !this.optionsObjRef?.current?.contains(event.target)) {
      this.setState({ showOptionsForObj: false })
    }
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }


  handleIncreaseObjZindex = () => {
    // ungroup();

    if (this.props.groupType == 'default') {
      this.props.obj.bringToFront();
      this.props.fabricInstance.renderAll();
      this.setState({ showOptionsForObj: false })
      this.props.saveDrawing();
      return;
    }
    this.props.grp.forEachObject((i) => {
      if (i == this.props.obj) {
        this.props.grp.removeWithUpdate(i);
        this.props.fabricInstance.add(i);
      }
    });
    this.props.fabricInstance.remove(this.props.obj);
    this.props.grp.addWithUpdate(this.props.obj);
    this.props.obj.bringToFront();

    this.props.grp.set("dirty", true);
    this.props.fabricInstance.renderAll();
    this.setState({ showOptionsForObj: false })
    this.props.saveDrawing();

    // Updating state in canvas
    this.updateCanvasContainer();
  }

  handleDecreaseObjZindex = () => {
    // ungroup();
    if (this.props.groupType == 'default') {
      this.props.obj.sendToBack();
      this.props.fabricInstance.renderAll();
      this.setState({ showOptionsForObj: false })
      this.props.saveDrawing();
      return;
    }
    this.props.grp.forEachObject((i) => {
      if (i == this.props.obj) {
        this.props.grp.removeWithUpdate(i);
        this.props.fabricInstance.add(i);
      }
    });
    this.props.fabricInstance.remove(this.props.obj);
    this.props.grp.addWithUpdate(this.props.obj);
    this.props.obj.sendToBack();

    this.props.grp.set("dirty", true);
    this.props.fabricInstance.renderAll();
    this.setState({ showOptionsForObj: false })
    this.props.saveDrawing();

    // Updating state in canvas
    this.updateCanvasContainer();
  }

  handleDeleteObj = () => {
    if (this.props.groupType == 'default') {
      let pos = 0;
      this.props.fabricInstance._objects.map((obj, i) => {
        if (obj == this.props.obj) {
          pos = i;
        }
      })
      this.props.fabricInstance._objects.splice(pos, 1);
      this.props.fabricInstance.remove(this.props.fabricInstance.getActiveObject());
    } else {
      this.props.grp.remove(this.props.obj)
      this.props.fabricInstance.renderAll();
      if (this.props.grp._objects.length == 0) {
        this.props.fabricInstance.remove(this.props.grp);
      }
    }

    // Hide the dropdown option
    this.setState({ showOptionsForObj: false })

    // Updating data in the API
    this.props.saveDrawing();

    // Updating state in canvas
    this.updateCanvasContainer();
  }

  handleUngroup = () => {
    this.props.grp.forEachObject((i) => {
      if (i == this.props.obj) {
        this.props.grp.removeWithUpdate(i);
        this.props.fabricInstance.add(i);
      }
    });
    if (this.props.grp._objects.length == 0) {
      this.props.fabricInstance.remove(this.props.grp);
    }
    this.props.fabricInstance.renderAll();

    // Updating state in canvas
    this.updateCanvasContainer();
  }

  highlightObj = (e) => {
    if (this.props.obj) {
      this.props.fabricInstance.setActiveObject(this.props.obj);
      this.props.fabricInstance.renderAll();
      this.props.selectedObject([this.props.obj]);
    }
  }

  updateCanvasContainer = () => {
    let activeObject = this.props.fabricInstance.getActiveObject();
    if (activeObject !== undefined && activeObject) {
      if (activeObject._objects) {
        let activeObjects = [];
        activeObject._objects?.map(ob => {
          activeObjects.push(ob);
        });
        this.props.selectedObject(activeObjects);
      }
      else {
        this.props.selectedObject([activeObject]);
      }
    }
  }

  // Function to un-hide the element
  unHideElement = () => {
    if (this.props.groupType == 'default') {
      this.props.obj.set('visible', true);
    } else {
      this.props.grp.set('visible', true);
    }
    this.props.fabricInstance.renderAll();
    this.props.saveDrawing();
}

  //Function to unlock the element
  handleUnlock =  () => {
    const obj = {
        selectable:true,
        hasControls:true,
        editable:true,
        evented:true,
        lockMovementX:false,
        lockMovementY:false
    }
    if (this.props.groupType == 'default') {
      this.props.obj.set(obj);
    } else {
      this.props.grp.set(obj);
    }
    this.props.fabricInstance.renderAll();
  }

  render() {
    const { layerName, obj, index, selectedObjects } = this.props;
    return (
      <div>
        <div ref={this.objRef} className={`annote-obj ${selectedObjects?.[0] === obj ? 'active_obj' : ''}`} onClick={this.highlightObj}>
          <div className='label_name'>
            {layerName} {index + 1}
            {obj?.text?.trim()?.length > 0 ? <span>{obj?.text}</span> : ''}
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ padding: '4px' }} onClick={() => this.setState({ showOptionsForObj: !this.state.showOptionsForObj })}>
              <Options></Options>
            </div>
            {
              this.state.showOptionsForObj && <div className='layering-container' ref={this.optionsObjRef}>

                {
                  <div className="layering-dropdown">
                    <ul>
                      <li onClick={this.handleIncreaseObjZindex}>Bring to front</li>
                      <li onClick={this.handleDecreaseObjZindex}>Set to Back</li>
                      <hr />
                      {this.props.groupType != 'default' && <><li onClick={this.handleUngroup}>Ungroup</li> <hr /></>}
                      {<li onClick={() => this.handleDeleteObj()}>Delete</li>}
                      <hr />
                      <li onClick={this.unHideElement}>UnHide</li>
                      <li onClick={this.handleUnlock}>Unlock</li>
                    </ul>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state: any) => ({
    fabricInstance: state.wizard.fabricInstance,
    selectedObjects:state.wizard.selectedObjects
  }),
  {
    enableLayering,
    saveDrawing,
    selectedObject
  }
)(AnnotationObj)